<script>
  import { fade, fly } from "svelte/transition";
  //stores
  import { navigationStore } from "../../stores/navigationStore";
  import viewport from "../../actions/useViewport";
  import viewport2 from "../../actions/useViewport2";
  import viewport3 from "../../actions/useViewport3";

  //components
  import Card from "../../components/Card.svelte";
  import BenefitsBgBubbles from "./BenefitsBgBubbles.svelte";
  import BenefitsBgEl2 from "./BenefitsBgEl2.svelte";
  import BenefitsBgEl3 from "./BenefitsBgEl3.svelte";
  import PuzzleIcon from "../../icons/PuzzleIcon.svelte";
  import StarIcon from "../../icons/StarIcon.svelte";
  import ThumbUpIcon from "../../icons/ThumbUpIcon.svelte";
  import MediaQuery from "../../components/MediaQuery.svelte";
  import BgBubblesBenefitsMobile from "./Mobile/BgBubblesBenefitsMobile.svelte";

  export let card_1_header = "";
  export let card_1_text = "";
  export let card_2_header = "";
  export let card_2_text = "";
  export let card_3_header = "";
  export let card_3_text = "";

  let windowInnerHeight;

  let showCards = false;

  let showCard1_mobile = false;
  let showCard2_mobile = false;
  let showCard3_mobile = false;
</script>

<svelte:window bind:innerHeight={windowInnerHeight} />

<section
  id="benefits"
  use:viewport
  on:enterViewport={() => navigationStore.changeActiveItem("benefits")}
>
  <h1 use:viewport2 on:enterViewport={() => (showCards = true)}>Benefits</h1>

  <MediaQuery query="(max-width: 1280px)" let:matches>
    <!-- Mobile -->
    {#if matches}
      <BgBubblesBenefitsMobile />
    {/if}
  </MediaQuery>

  <MediaQuery query="(min-width: 1281px)" let:matches>
    <!-- Desktop -->
    {#if matches}
      <BenefitsBgBubbles />
      <BenefitsBgEl2 />
      <BenefitsBgEl3 />
      {#if showCards}
        <div in:fly={{ duration: 1000, x: -1000, y: -100 }}>
          <Card
            top="207"
            left="122"
            width="382"
            height="305"
            header={card_1_header}
            text={card_1_text}
          >
            <ThumbUpIcon />
          </Card>
        </div>

        <div in:fade={{ duration: 1000 }}>
          <Card
            top="207"
            left="529"
            width="382"
            height="305"
            header={card_2_header}
            text={card_2_text}
          >
            <PuzzleIcon />
          </Card>
        </div>

        <div in:fly={{ duration: 1000, x: 1000, y: -100 }}>
          <Card
            top="207"
            left="936"
            width="382"
            height="305"
            header={card_3_header}
            text={card_3_text}
          >
            <StarIcon />
          </Card>
        </div>
      {/if}
    {:else}
      <div class="cards-wrapper-mobile">
        {#key showCard1_mobile}
          <div
            use:viewport3
            on:enterViewport={() => {
              showCard1_mobile = true;
            }}
            in:fly={{ duration: 1000, x: -1000, y: -100, delay: 750 }}
          >
            <Card
              position="relative"
              top="40"
              left="0"
              width="328"
              height="305"
              header={card_1_header}
              text={card_1_text}
            >
              <ThumbUpIcon />
            </Card>
          </div>
        {/key}
        {#key showCard2_mobile}
          <div
            use:viewport3
            on:enterViewport={() => {
              showCard2_mobile = true;
            }}
            in:fade={{ duration: 1000, delay: 750 }}
          >
            <Card
              position="relative"
              top="64"
              left="0"
              width="328"
              height="305"
              header={card_2_header}
              text={card_2_text}
            >
              <PuzzleIcon />
            </Card>
          </div>
        {/key}
        {#key showCard3_mobile}
          <div
            use:viewport3
            on:enterViewport={() => {
              showCard3_mobile = true;
            }}
            in:fly={{ duration: 1000, x: 1000, y: -100, delay: 750 }}
          >
            <Card
              position="relative"
              top="87"
              left="0"
              width="328"
              height="305"
              header={card_3_header}
              text={card_3_text}
            >
              <StarIcon />
            </Card>
          </div>
        {/key}
      </div>
    {/if}
  </MediaQuery>
</section>

<style>
  section {
    /* border: 1px red solid; */
    position: relative;
    width: 1440px;
    height: 415px;
    left: -32px;
    top: 80px;
    margin-top: 10px;

    /* Light */
    background: #e6edf6;
  }

  h1 {
    position: absolute;
    width: 142px;
    height: 49px;
    left: 649px;
    top: 100px;

    font-style: normal;
    font-weight: 800;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    /* Blue */
    color: #5666ed;
  }

  @media (max-width: 1280px) {
    /* Phones and Tablets*/
    section {
      width: 100%;
      left: 0;
      height: 898px;

      display: flex;
      flex-direction: column;
      align-items: center;
    }

    h1 {
      position: static;
      margin-top: 40px;
      font-size: 28px;
    }
    .cards-wrapper-mobile {
      position: relative;
      width: 100%;

      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
</style>
